export const PAYROLL_NOVELTY_STATUS = {
    Approved: {
        description: 'Aprobado',
        color: '#4CAF50',
        id: 2,
    },
    Rejected: {
        description: 'Rechazado',
        color: '#F44336',
        id: 3,
    },
    Review: {
        description: 'Revisado',
        color: '#E8BC52',
        id: 1,
    },
    Draft: {
        description: 'Borrador',
        color: '#2196F3',
        id: 0,
    },
    Undefined: {
        description: '',
        color: '#F3F6F9',
        id: 0,
    },
};
